<template>
  <div class="table-wrap" :class="{ 'table-wrap--split': layout === 'split', 'table-wrap--compact': compact }" role="table" :aria-label="caption">
    <div class="table-row table-head" role="row" :style="gridStyle">
      <span v-for="col in columns" :key="col" role="columnheader">{{ col }}</span>
    </div>
    <div v-for="(row, i) in rows" :key="i" class="table-row" role="row" :style="gridStyle">
      <span v-for="(cell, j) in row" :key="j" role="cell" class="table-cell">
        <template v-if="cellTone(cell, j)">
          <svg
            class="table-cell-icon"
            :class="`table-cell-icon--${cellTone(cell, j)}`"
            viewBox="0 0 16 16"
            aria-hidden="true"
          >
            <!-- 轻量勾选 -->
            <path
              v-if="cellTone(cell, j) === 'ok'"
              d="M3.2 8.2 6.4 11.4 12.8 4.8"
              fill="none"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <!-- 轻量叉号 -->
            <path
              v-else-if="cellTone(cell, j) === 'bad'"
              d="M4.2 4.2 11.8 11.8M11.8 4.2 4.2 11.8"
              fill="none"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />
            <!-- 轻量警告 -->
            <g v-else-if="cellTone(cell, j) === 'warn'" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
              <path d="M8 2.8 13.4 12.6H2.6Z" />
              <path d="M8 6.2v2.8" />
              <path d="M8 11.1h.01" />
            </g>
          </svg>
          <span class="table-cell-text">{{ cellText(cell) }}</span>
        </template>
        <template v-else>{{ cell }}</template>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleTable',
  props: {
    columns: {
      type: Array,
      required: true,
    },
    rows: {
      type: Array,
      required: true,
    },
    caption: {
      type: String,
      default: '',
    },
    layout: {
      type: String,
      default: 'auto',
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    gridStyle() {
      const count = this.columns.length;
      if (this.layout === 'split') {
        return {
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        };
      }
      if (count === 2) {
        return {
          gridTemplateColumns: 'minmax(150px, 0.38fr) minmax(0, 1fr)',
        };
      }
      return {
        gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))`,
      };
    },
  },
  methods: {
    // 支持字符串或 { text, tone } 对象
    isRichCell(cell) {
      return cell && typeof cell === 'object' && !Array.isArray(cell);
    },
    cellText(cell) {
      return this.isRichCell(cell) ? cell.text : cell;
    },
    cellTone(cell, index) {
      if (this.isRichCell(cell) && cell.tone) {
        return cell.tone;
      }
      if (this.layout === 'split') {
        return index === 0 ? 'ok' : 'bad';
      }
      return '';
    },
  },
};
</script>
